'use client';
import { useEffect, useState } from 'react';
import { clsx } from 'clsx';
import { checkIsOpenStatus } from '@/utils/checkIsOpenStatus';
import s from './StatusOpen.module.scss';
import { IWithClassname } from '@/models/common';

interface Props extends IWithClassname {
  openTime?: string | null;
  closeTime?: string | null;
}

const INTERVAL = 60000;

export default function StatusOpen  ({ openTime, closeTime, className }: Props)  {
  const [isOpen, setIsOpen] = useState(() => checkIsOpenStatus(openTime, closeTime));

  const updateStatus = () => {
    setIsOpen(checkIsOpenStatus(openTime, closeTime));
  };

  useEffect(() => {
    const intervalId = setInterval(updateStatus, INTERVAL);

    return () => clearInterval(intervalId);
  }, [openTime, closeTime]);

  return (
    <div className={clsx(s.status, className, { [s.status_closed]: !isOpen })}>
      {isOpen ? 'сейчас открыто' : 'закрыто'}
    </div>
  );
};